import { useQuery } from '@pinia/colada';

import companyService from '../services/company.service';

export const companyQueryKey = 'company';

export function useCompanyQuery() {
  return useQuery({
    key: () => [companyQueryKey],
    query: () => companyService.loadCompany(),
    gcTime: false,
    staleTime: 24 * 60 * 60 * 1000, // 1 day
  });
}
